const obj = {
  columnUrl:{
    //获取一级列表
    getSonCategoryEdit: '/content/topic/getTopicTree', 
    //获取一级下的所有子目录
    treeEdit: "/content/topic/getTopicChildNode/", 
    /*删除类目*/
    deleteEdits: "/content/topic/removeTopic/",
    /**添加类目*/
    addEdits: "/content/topic/saveTopic",
    /*类目编辑*/
    updateEdits: "/content/topic/editTopic",
    /*类目拖拽*/
    freeMove: "/content/topic/freeMove",
    /*上下移动*/
    siblingMove: "/content/topic/changePosition",
    //基本信息
    editProfile: "/content/topic/getTopicDetail/",
  }
}
export default obj;